import { useEffect, useRef, useState, type RefObject } from "react";

type StickyCheckoutBarState = [
  canRender: boolean,
  topRef: RefObject<HTMLDivElement>,
  bottomRef: RefObject<HTMLDivElement>,
];

export const useStickyCheckoutBar = (): StickyCheckoutBarState => {
  const topRef = useRef<HTMLDivElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);
  const [topCheckoutPassed, setTopCheckoutPassed] = useState(false);
  const [bottomCheckoutVisible, setBottomCheckoutVisible] = useState(false);

  useEffect(() => {
    const topCheckout = topRef.current;
    const bottomCheckout = bottomRef.current;
    if (!topCheckout || !bottomCheckout || typeof IntersectionObserver === "undefined") {
      return;
    }

    const topObserver = new IntersectionObserver(([entry]) => {
      const viewportTop = entry.rootBounds?.top ?? 0;
      setTopCheckoutPassed(!entry.isIntersecting && entry.boundingClientRect.bottom <= viewportTop);
    });
    const bottomObserver = new IntersectionObserver(([entry]) => setBottomCheckoutVisible(entry.isIntersecting));

    topObserver.observe(topCheckout);
    bottomObserver.observe(bottomCheckout);

    return () => {
      topObserver.disconnect();
      bottomObserver.disconnect();
    };
  }, []);

  return [topCheckoutPassed && !bottomCheckoutVisible, topRef, bottomRef];
};
